import React, { useState, useMemo, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLanguage } from '../../../../contexts/LanguageContext';

const OrderBalanceCollectionTable = ({
  data,
  totalRecords,
  isLoading,
  onPage,
  lazyParams,
  resetPagination = false
}) => {
  const { th } = useLanguage();
  const safeParams = lazyParams || { page: 1, rows: 10 };

  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [currentFirst, setCurrentFirst] = useState(0);

  useEffect(() => {
    if (resetPagination) {
      setCurrentFirst(0);
      setSortField(null);
      setSortOrder(null);
    }
  }, [resetPagination]);

  const handlePage = (event) => {
    setCurrentFirst(event.first);
    onPage(event);
  };

  const onSort = (event) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
  };

  const sortedData = useMemo(() => {
    if (!sortField || !data) return data;
    return [...data].sort((a, b) => {
      const aVal = a?.[sortField];
      const bVal = b?.[sortField];

      if (aVal === null || aVal === undefined) return 1;
      if (bVal === null || bVal === undefined) return -1;

      let comparison = 0;
      if (typeof aVal === 'string' && typeof bVal === 'string') {
        comparison = aVal.localeCompare(bVal, 'tr', { numeric: true });
      } else if (typeof aVal === 'number' && typeof bVal === 'number') {
        comparison = aVal - bVal;
      } else {
        comparison = aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
      }

      return (sortOrder || 1) * comparison;
    });
  }, [data, sortField, sortOrder]);

  return (
    <DataTable
      value={sortedData}
      paginator
      lazy
      first={currentFirst}
      rows={safeParams.rows}
      totalRecords={totalRecords}
      loading={isLoading}
      onPage={handlePage}
      onSort={onSort}
      sortField={sortField}
      sortOrder={sortOrder}
      rowsPerPageOptions={[5, 10, 25, 50, 100, 500, 1000]}
      dataKey="id"
      tableStyle={{ minWidth: '60rem' }}
      showGridlines
      stripedRows
      emptyMessage={th('parts.notFoundOrderBalanceCollection')}
      removableSort
      sortMode="single"
    >
      
    <Column field="shipmentPriorityCode" header={th('parts.orderPriority')} sortable />
<Column field="dealerOrderNo" header={th('parts.dealerOrderNo')} sortable />
<Column field="dealerId" header={th('parts.dealerNo')} sortable />
<Column field="dealerSiteId" header={th('parts.dealerSiteId')} sortable />
<Column field="orderNo" header={th('parts.orderNo')} sortable />
<Column field="orderPartCode" header={th('parts.salesCode')} sortable />
<Column field="orderQuantity" header={th('parts.orderQuantity')} sortable />
<Column field="orderAmount" header={th('parts.orderAmount')} sortable />
<Column field="pickedQuantity" header={th('parts.collectedQuantity')} sortable />
<Column field="pickedAmount" header={th('parts.collectedAmount')} sortable />
<Column field="konsinyePickedQuantity" header={th('parts.consignmentCollectedQuantity')} sortable />
<Column field="konsinyePickedAmount" header={th('parts.consignmentCollectedAmount')} sortable />
<Column field="remainingBalance" header={th('parts.remainingBalance')} sortable />
<Column field="stock " header={th('parts.stock')} sortable />
<Column field="unitPrice  " header={th('parts.unitPrice')} sortable />
<Column field="totalRetailCustomerPrice   " header={th('parts.totalRetailCustomerPrice')} sortable />
</DataTable>
  );
};

export default OrderBalanceCollectionTable;
